import React from "react";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Nivel from "./Nivel";
import Bomba from "./Bomba";
import Vazao from "./Vazao";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      json: { nivel: [], bomba: [], vazao: [] },
      loading: true,
      error: null,
    };
    this.buttonLoading = this.buttonLoading.bind(this);
    this.callApi = this.callApi.bind(this);
  }
  async componentDidMount() {
    this.setState({
      loading: true,
    });
    await this.callApi();
    setInterval(async () => {
      this.setState({
        loading: true,
      });
      await this.callApi();
    }, 1000 * 60);
  }
  async callApi() {
    const API = process.env.REACT_APP_URL_API;
    const SERVER = process.env.REACT_APP_URL_SERVER;

    // Validação: verifica se a URL da API está definida
    if (!API) {
      const errorMsg =
        "REACT_APP_URL_API não está definida nas variáveis de ambiente. Verifique o arquivo .env";
      console.error(errorMsg);
      this.setState({
        json: { nivel: [], bomba: [], vazao: [] },
        loading: false,
        error: errorMsg,
      });
      return;
    }

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    if (SERVER) {
      headers.append("Origin", SERVER);
    }

    try {
      const response = await fetch(API, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error(
          `Erro na API: ${response.status} ${response.statusText}`
        );
      }

      const json = await response.json();
      this.setState({
        json,
        loading: false,
        error: null,
      });
    } catch (error) {
      console.error("Erro ao buscar dados da API:", error);
      this.setState({
        json: { nivel: [], bomba: [], vazao: [] },
        loading: false,
        error: `Erro ao conectar com a API: ${error.message}`,
      });
    }
  }
  buttonLoading() {
    return (
      <Button variant="primary" disabled>
        <Spinner
          as="span"
          animation="grow"
          size="sm"
          role="status"
          aria-hidden="true"
        />
        Carregando...
      </Button>
    );
  }
  render() {
    const { loading, error } = this.state;
    const { nivel, bomba, vazao } = this.state.json;
    return (
      <main className="text-center justify-content-between">
        {loading ? this.buttonLoading() : ""}
        {error && (
          <div className="alert alert-danger container mt-3" role="alert">
            <strong>Erro:</strong> {error}
            <br />
            <small>
              Verifique se a URL da API está configurada corretamente no arquivo
              .env
            </small>
          </div>
        )}
        {nivel && nivel.length > 0 ? (
          <div className="container">
            <h4 className="card-title">Níveis</h4>
            <Nivel nivel={nivel} />
          </div>
        ) : (
          <div></div>
        )}
        {bomba && bomba.length > 0 ? (
          <div className="container">
            <h4 className="card-title">Bombas</h4>
            <Bomba bomba={bomba} />
          </div>
        ) : (
          <div></div>
        )}
        {vazao && vazao.length > 0 ? (
          <div className="container">
            <h4 className="card-title">Hidrômetros de Vazão</h4>
            <Vazao vazao={vazao} />
          </div>
        ) : (
          <div></div>
        )}
      </main>
    );
  }
}

export default Main;
